import React, { useEffect, useState } from 'react'
import TripImage from '../../assets/trip.jpg'
import { useParams } from "react-router-dom";
import TripFlag from '../../assets/flag.jpg'
import ShoesImg from '../../assets/shoes.png'
import BagImg from '../../assets/tote-bag 1.png'
import TravelBag from '../../assets/travel_pack.png'
import DayBag from '../../assets/day_pack.png'
import HipBag from '../../assets/hip_pack.png'
import Laundry from '../../assets/laundry-service 1.png'
import { FaArrowLeft } from "react-icons/fa6";

import {
    BottleBabyIcon,
    BottleIcon,
    CameraDslrIcon,
    CameraIcon,
    CameraLensIcon,
    CameraMirorIcon,
    CloudyIcon,
    ColdBigIcon,
    ColdIcon,
    CompassIcon,
    EReaderIcon,
    EsProductsIcon,
    HotSaleIcon,
    LaptopIcon,
    LuggageIcon,
    OutdoorIcon,
    StackIcon,
    SuiteCaseIcon,
    TabletIcon,
    TravelIcon,
    UrbanIcon,
    WorkerIcon,
    WorkerWomenIcon,
    ReportIcon,
    CrownIcon,
    GoProIcon
} from '../../utils/icons'
import { Link } from 'react-router-dom'
import CurvedImg from '../../components/curvedImg'
import ReactPlayer from 'react-player'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useGetPackingListByIdQuery } from '../../services/Api';
import { BASE_URL_IMAGE } from '../../services/ApiEndpoints';
import { FaLongArrowAltDown, FaLongArrowAltUp } from "react-icons/fa";
import { FiChevronDown } from 'react-icons/fi';
import Button from '../../components/button';
import { AiOutlineClose, AiOutlineHeart } from 'react-icons/ai';
import { LuCrown } from 'react-icons/lu';
import { useSelector } from "react-redux";
import { useSavePackingListMutation } from '../../services/Api';
import { toast } from 'react-toastify';
import Spiner from '../../components/spinner';
import { MdArrowOutward } from "react-icons/md";
import EarthImg from '../../assets/earth.png'
import { countryOptions } from '../adminPanel/pages/addPackingList/utils';
import { PiPlayCircleThin } from "react-icons/pi";

const TripDetails = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const [proCard, setProCard] = useState(false)
    const [contentShow, setContentShow] = useState(false)
    const [showTags, setShowTags] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const auth = useSelector((data) => data?.auth);
    const [savePackingList, { isLoading: saveLoading }] = useSavePackingListMutation()
    const [state, setState] = useState({
        isDestinationOpen: false,
        isTagsOpen: false,
    });
    const { id } = useParams(); // Get the dynamic ID from the route
    const { data, isLoading, error } = useGetPackingListByIdQuery(id, {
        skip: !id, // Skip the query if ID is not present
    });

    const tripDetail = data && data?.data
    useEffect(() => {
        setProCard(tripDetail?.type == 'PRO' ? true : false)
    }, [JSON.stringify(tripDetail)]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Adds a smooth scrolling effect
        });
    }, [])

    // console.log("data in trip", tripDetail)

    const AssesList = [
        {
            icon: CameraDslrIcon,
            title: 'DLSR',
        },
        {
            icon: CloudyIcon,
            title: 'Mild',
        },
        {
            icon: LaptopIcon,
            title: 'Laptop',
        },
        {
            icon: CameraMirorIcon,
            title: 'Mirrorless',
        },
        {
            icon: CameraLensIcon,
            title: 'Lens',
        },
    ]
    const tagsList = [
        {
            icon: CameraDslrIcon,
            title: 'DLSR',
        },
        {
            icon: CloudyIcon,
            title: 'Mild',
        },
        {
            icon: LaptopIcon,
            title: 'Laptop',
        },
        {
            icon: CameraMirorIcon,
            title: 'Mirrorless',
        },
        {
            icon: CameraLensIcon,
            title: 'Lens',
        },
    ]

    const savePackingListHandel = async () => {
        if (auth?.isLoggedIn) {
            try {
                const response = await savePackingList({ id });
                toast.success('Packing List Save');
            } catch (error) {
                // console.error("Error:", error);
            }
        } else {
            toast.success('Please Login to Save Packing List');
            navigate('/login')
        }
    }
    const selectedCountry = tripDetail?.destinations?.length
        ? countryOptions.find((c) => c.value === tripDetail.destinations[0]?.country?.[0])
        : null;
    // console.log("data in", tripDetail)

    const TagCard = ({ title, bg }) => {
        return (
            <div className={`${bg == 'primary' ? 'bg-bgprimary text-dark' : 'bg-orange text-bgprimary'}  font-roboto-mono font-bold rounded-md px-2 py-1`}>
                {title}
            </div>
        )
    }
    return (
        <>
            {isLoading ?
                <div className="relative h-screen">
                    <Spiner />
                </div>
                :
                <div className={'bg-aths'}  >
                    <div className={``}>
                        <div className="bg-bgprimary min-h-[27rem] relative">
                            {proCard && (
                                <div className="bottom-5 right-[12%] absolute z-10">
                                    {/* <span className={` bg-[#F0D23C] w-16 flex  text-orange font-quicksand text-base font-bold border border-white px-3 py-1 rounded-full`}>
                                        PRO
                                    </span> */}
                                    <button onClick={() => setIsModalOpen(true)} className='flex justify-center gap-1 w-fit mt-2 items-center bg-white   text-black font-quicksand text-base font-bold border border-white px-3 py-1 rounded-[6px]' >
                                        <PiPlayCircleThin size={20} /> Play Video
                                    </button>
                                </div>

                            )}
                            <img src={`${BASE_URL_IMAGE}${tripDetail?.thumbnail}`} className='w-full h-[550px] object-cover  ' alt="" />
                            {/* <div className="flex absolute md:bottom-2 bottom-1 left-2 items-center justify-center gap-4">
                                <h3 className={`md:text-3xl text-lg  font-roboto-mono  italic font-bold text-dark}`}> {tripDetail?.title} <span className={`md:text-lg text-sm  font-roboto-mono font-normal text-dark`}>By {tripDetail?.creator}</span> </h3>

                            </div> */}
                        </div>


                    </div>

                    <div className="max-w-[1050px] mx-auto py-10 px-4">

                        <div className="grid md:grid-cols-2 grid-cols-1 gap-8 mt-8">
                            <div className={` rounded-[20px] ${proCard ? 'bg-green' : 'bg-bgprimary'} p-5 h-fit`}>
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center justify-start gap-4 mb-2">
                                        <div className="border-2 w-12 h-12 border-bgprimary rounded-full">
                                            <img
                                                src={tripDetail?.creatorImage ? `${BASE_URL_IMAGE}${tripDetail?.creatorImage}` : 'UserImage'}
                                                alt="Profile"
                                                className="w-full h-full rounded-full object-cover"
                                            />
                                        </div>
                                        <h3 className={`text-sm font-quicksand font-bold ${proCard ? 'text-bgprimary' : 'text-dark'}`}>by {tripDetail?.creator}</h3>

                                    </div>
                                    <div className="">
                                        {proCard && (
                                            <span className={` bg-[#F0D23C]  text-orange font-quicksand text-[15px] font-bold border border-white p-1 rounded-[6px]`}>
                                                Pro
                                            </span>
                                        )}
                                    </div>
                                </div>


                                <div className="ml-2 w-full text-left">
                                    <h2 className={`text-base font-roboto-mono italic font-bold line-clamp-2 ${proCard ? 'text-bgprimary' : 'text-dark'} `}>
                                        {tripDetail?.title}
                                    </h2>
                                    {/* <p className={`text-[14px] font-quicksand text-left font-normal ${proCard ? 'text-bgprimary' : 'text-dark'}`}>Description</p> */}
                                    <p className={`text-[13px] text-left font-quicksand font-noraml line-clamp-5 ${proCard ? 'text-bgprimary' : 'text-dark'}`}>{tripDetail?.description}
                                    </p>


                                </div>
                            </div>
                            <div className="">
                                <div className="border-[6px] border-[#FFFFFF] p-4 rounded-[20px] h-fit mb-6">
                                    <h3 className='text-dark font-roboto-mono font-bold italic text-lg mx-auto text-left max-w-[700px] flex items-center ' >
                                        To Know
                                        <span className='hover:cursor-pointer'
                                            onClick={() => setContentShow(!contentShow)}
                                        >
                                            {contentShow ?
                                                <FaLongArrowAltUp />
                                                : <FaLongArrowAltDown />}
                                        </span>
                                    </h3>
                                    {contentShow ?
                                        <>
                                            <p className='text-dark font-quicksand font-medium text-[16px] text-left max-w-[650px] mx-auto' >
                                                Icons next to the cube images show if they're compressed or expanded. Compressed cubes can expand to hold more, while expanded ones offer flexibility. <b>Check the product for details You can save this Packing List for future reference.</b>
                                            </p>

                                        </>
                                        : ''
                                    }
                                </div>
                                <div className="border-[6px] border-[#FFFFFF] p-4 rounded-[20px] h-fit">
                                    <h3 className='text-dark font-roboto-mono font-bold italic text-lg mx-auto text-left max-w-[700px] flex items-center ' >
                                        View Filters and tags
                                        <span className='hover:cursor-pointer'
                                            onClick={() => setShowTags(!showTags)}
                                        >
                                            {showTags ?
                                                <FaLongArrowAltUp />
                                                : <FaLongArrowAltDown />}
                                        </span>
                                    </h3>
                                    {showTags ?
                                        <div className='flex items-center gap-3 flex-wrap py-2' >
                                            <TagCard title={tripDetail?.type} bg={'primary'} />
                                            <TagCard title={tripDetail?.bodyType} bg={'primary'} />
                                            {tripDetail?.tags?.map((item) => (
                                                <TagCard title={item?.name} key={item?._id} bg={'primary'} />
                                            ))}
                                            {!tripDetail?.destinations?.length || tripDetail?.destinations.length > 1 || tripDetail?.destinations?.[0]?.region ? (
                                                <>
                                                    {tripDetail?.destinations?.map((dest, idx) => (
                                                        <TagCard title={`${dest?.region} ${dest?.country} ${dest?.state} ${dest?.city}`} key={dest?._id} bg={'primary'} />
                                                    ))}
                                                </>
                                            ) : selectedCountry ? (
                                                // <TagCard title={tripDetail?.destinations[0]?.country[0]} bg={'primary'} />
                                                <img
                                                    src={`https://flagcdn.com/w320/${selectedCountry && selectedCountry?.code?.toLowerCase()}.png`}
                                                    alt="Flag"
                                                    className="w-16 h-7 object-fill rounded shadow-lg"
                                                />
                                            ) : (
                                                <img
                                                    src={EarthImg}
                                                    alt="Globe"
                                                    className="h-4 rounded shadow-lg"
                                                />
                                            )}
                                            <TagCard title={tripDetail?.packingStyle} bg={'orange'} />
                                            <TagCard title={tripDetail?.duration == -1 ? "Long-Term" : `${tripDetail?.duration} Days`} bg={'primary'} />
                                            <TagCard title={tripDetail?.activityScale} bg={'primary'} />
                                            {tripDetail?.climate?.map((climate) => {
                                                return (
                                                    <TagCard title={climate?.climateType} bg={'primary'} />
                                                )
                                            })}
                                            {tripDetail?.tech?.map((tech) => {
                                                <TagCard title={tech} bg={'primary'} />
                                            })}
                                            {tripDetail?.toiletry?.map((toiletry) => {
                                                <TagCard title={toiletry} bg={'primary'} />
                                            })}
                                            {proCard && (
                                                <span className={` bg-[#F0D23C]  text-orange font-quicksand text-[15px] font-bold border border-white p-1 rounded-[6px]`}>
                                                    Pro
                                                </span>
                                            )}
                                        </div>
                                        : ''
                                    }
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="max-w-[1050px] mx-auto py-7 px-4">
                        {tripDetail?.widgets?.slice(0,)?.map((item) => {
                            return (
                                <div className="grid md:grid-cols-7 grid-cols-1 my-10  gap-6 border-[6px] border-bgprimary rounded-xl mt-12 p-4" key={item?._id}>
                                    <div className={`img border-[6px] h-[250px] md:col-span-2 col-span-1  z-10 rounded-[17px]  ${["quickTrip", "mediumCube", "largeCube"].includes(item?.type) ? 'border-orange' : 'border-aths'}  overflow-hidden w-full`}>

                                        <div className="relative w-full h-full">
                                            <img src={item?.image ? `${BASE_URL_IMAGE}${item?.image}` : TripImage} className='w-full h-full rounded-[12px] object-cover  ' alt="" />
                                            {/* <div className="absolute bottom-5 left-0 w-full h-[10px] bg-transparent">
                                                <div className={`absolute bottom-0 left-[50%] inset-0 w-full h-full bg-transparent after:content-[''] after:block after:w-[170px] after:h-[100px] ${["quickTrip", "mediumCube", "largeCube"].includes(item?.type) ? 'after:bg-orange' : 'after:bg-aths'}  after:rounded-[100%] after:scale-x-[2] after:translate-x-[-50%] after:opacity-100`}></div>
                                            </div> */}
                                            {["quickTrip", "mediumCube", "largeCube"].includes(item?.type) && (
                                                <a href={item?.url} className='z-10 absolute left-[50%] translate-x-[-50%] bottom-[3%] bg-white border-2 rounded-[0px] border-black py-2 px-2 font-quicksand font-semibold text-base text-dark flex gap-1 items-center' target='_blank' ><MdArrowOutward size={20} className="text-dark mb-1" />  Discover</a>
                                            )}
                                        </div>
                                    </div>
                                    <div className=" md:col-span-5 col-span-1  w-full   overflow-hidden">
                                        <ul className='md:pl-4' >
                                            <h2 className={` capitalize text-2xl text-left font-roboto-mono mb-1 italic font-bold ${!["quickTrip", "mediumCube", "largeCube"].includes(item?.type) ? 'text-dark' : 'text-dark'} `}>
                                                {item?.type?.replace(/([A-Z])/g, " $1")}
                                            </h2>
                                            {item?.items?.map((item, index) => {
                                                return (
                                                    <li key={index} className=' mb-2' >
                                                        <div className="flex justify-start items-center">
                                                            <div className="">
                                                                <div className="">
                                                                    <div className="flex items-center gap-2">
                                                                        <div className="w-1 h-1 rounded-full bg-dark"></div>
                                                                        <span className='font-semibold font-quicksand text-base text-dark' >{item?.name} x{item?.quantity}</span>
                                                                    </div>
                                                                </div>
                                                                {item?.notes && (
                                                                    <ul>
                                                                        <li className='font-semibold font-quicksand rounded-xl text-sm text-dark bg-bgprimary py-1 px-2 w-fit break-all whitespace-normal mt-1' >
                                                                            {item?.notes}
                                                                        </li>
                                                                    </ul>
                                                                )}
                                                            </div>
                                                            {item?.isDiscover && (
                                                                <a className=' bg-white border-2 rounded-[0px] ml-5 border-black py-2  px-2 font-quicksand font-semibold text-sm text-dark flex gap-1 items-center ' href={item?.url} target='_blank' > <MdArrowOutward size={20} className="text-dark mb-1" /> Discover</a>
                                                            )}
                                                        </div>


                                                    </li>
                                                )
                                            })}


                                        </ul>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className="max-w-[1050px] mx-auto py-10 px-4">
                        <div className="grid md:grid-cols-2 grid-cols-1 gap-6">

                            <div className={` rounded-lg border-[6px] bg-bgprimary border-bgprimary h-auto ${tripDetail?.laundryBag.type == 'pro' ? 'border-bgprimary' : 'border-bgprimary'}  p-4 `}>
                                <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
                                    <CurvedImg img={tripDetail?.laundryBag.laundryBagImage !== 'null' ? `${BASE_URL_IMAGE}${tripDetail?.laundryBag.laundryBagImage}` : BagImg} bgcolor={tripDetail?.laundryBag?.type == 'pro' ? `orange` : 'bgprimary'} />
                                    <div className="flex flex-col justify-between gap-3 w-full ">
                                        <div className="">
                                            <h2 className={`text-xl  font-roboto-mono mb-3 font-bold ${tripDetail?.laundryBag.type == 'pro' ? 'text-dark' : 'text-dark'} `}>
                                                {tripDetail?.laundryBag?.name ? tripDetail?.laundryBag?.name : 'Laundry Bag'}
                                            </h2>
                                            <p className={`text-sm font-quicksand mb-3 font-normal ${tripDetail?.laundryBag.type == 'pro' ? 'text-dark' : 'text-dark'} `}>
                                                {tripDetail?.laundryBag?.description}
                                            </p>
                                            <a className=' bg-white border-2 rounded-[0px] border-black py-2 w-fit  px-2 font-quicksand font-semibold text-base text-dark flex gap-1 items-center ' href={tripDetail?.laundryBag?.url} target='_blank' > <MdArrowOutward size={20} className="text-dark" /> Discover</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`rounded-xl  border-[6px] border-bgprimary bg-bgprimary p-4 `}>

                                <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
                                    <CurvedImg img={tripDetail?.travelPack?.travelPackImage !== 'null' ? `${BASE_URL_IMAGE}${tripDetail?.travelPack?.travelPackImage}`.replace(/['"]/g, '') : TravelBag} bgcolor={tripDetail?.travelPack?.type == 'pro' ? `orange` : 'bgprimary'} />
                                    <div className="self-center flex flex-col justify-between w-full h-full">
                                        <div className="">
                                            <h2 className={`text-xl  font-roboto-mono mb-3 italic font-bold ${tripDetail?.travelPack?.type == 'pro' ? 'text-dark' : 'text-dark'} `}>
                                                {tripDetail?.travelPack?.name ? tripDetail?.travelPack?.name : `Travel Pack - ${tripDetail?.travelPack?.size}`}
                                            </h2>
                                            <p className={`text-sm font-quicksand mb-3 break-all whitespace-normal font-normal ${tripDetail?.laundryBag.type == 'pro' ? 'text-dark' : 'text-dark'} `}>
                                                {tripDetail?.travelPack?.description}
                                            </p>
                                            {tripDetail?.travelPack?.type == 'pro' && tripDetail?.travelPack?.url &&
                                                <a className=' bg-white border-2 rounded-[0px] border-black py-2 w-fit  px-2 font-quicksand font-semibold text-base text-dark flex gap-1 items-center' href={tripDetail?.travelPack?.url} target='_blank' > <MdArrowOutward size={20} className="text-dark" /> Discover</a>
                                            }
                                        </div>


                                    </div>
                                </div>
                            </div>
                            <div className={`rounded-xl  md:h-[270px] border-[6px] border-bgprimary  bg-bgprimary p-4 `}>

                                <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
                                    <CurvedImg img={tripDetail?.dayPack?.dayPackImage !== 'null' ? `${BASE_URL_IMAGE}${tripDetail?.dayPack?.dayPackImage}` : DayBag} bgcolor={tripDetail?.dayPack?.type == 'pro' ? `orange` : 'bgprimary'} />
                                    <div className="self-center flex flex-col justify-between w-full h-full">
                                        <div className="">
                                            <h2 className={`text-xl  font-roboto-mono italic mb-3 font-bold ${tripDetail?.dayPack?.type == 'pro' ? 'text-dark' : 'text-dark'} `}>
                                                {tripDetail?.dayPack?.name
                                                    ? tripDetail?.dayPack?.name
                                                    : `Day Pack${tripDetail?.dayPack?.size ? ` - ${tripDetail?.dayPack?.size}` : ''}`}
                                            </h2>
                                            <p className={`text-sm font-quicksand mb-3 break-all whitespace-normal font-normal ${tripDetail?.laundryBag.type == 'pro' ? 'text-dark' : 'text-dark'} `}>
                                                {tripDetail?.dayPack?.description}
                                            </p>
                                            {tripDetail?.dayPack?.type == 'pro' && tripDetail?.dayPack?.url &&
                                                <a className=' bg-white border-2 rounded-[0px] border-black py-2 w-fit  px-2 font-quicksand font-semibold text-base text-dark flex gap-1 items-center' href={tripDetail?.dayPack?.url} target='_blank' ><MdArrowOutward size={20} className="text-dark" /> Discover</a>

                                            }
                                        </div>


                                    </div>
                                </div>
                            </div>
                            <div className={`rounded-xl  border-[6px] border-bgprimary bg-bgprimary  p-4 md:h-[270px] `}>

                                <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
                                    <CurvedImg img={tripDetail?.hipPack?.hipPackImage !== 'null' ? `${BASE_URL_IMAGE}${tripDetail?.hipPack?.hipPackImage}` : HipBag} bgcolor={tripDetail?.hipPack?.type == 'pro' ? `orange` : 'bgprimary'} />
                                    <div className="self-center flex flex-col justify-between w-full h-full">
                                        <div className="">
                                            <h2 className={`text-xl  font-roboto-mono italic mb-3 font-bold ${tripDetail?.hipPack?.type == 'pro' ? 'text-dark' : 'text-dark'} `}>
                                                {(tripDetail?.hipPack?.type == 'pro' && tripDetail?.hipPack?.name) ? tripDetail?.hipPack?.name : ` Hip Pack - ${tripDetail?.hipPack?.size}`}
                                            </h2>
                                            <p className={`text-sm font-quicksand break-all whitespace-normal mb-3 font-normal ${tripDetail?.laundryBag.type == 'pro' ? 'text-dark' : 'text-dark'} `}>
                                                {tripDetail?.hipPack?.description}
                                            </p>
                                            {tripDetail?.hipPack?.type == 'pro' && tripDetail?.hipPack?.url &&
                                                <a className=' bg-white border-2 rounded-[0px] border-black py-2 w-fit  px-2 font-quicksand font-semibold text-base  gap-1 text-dark flex items-center' href={tripDetail?.hipPack?.url} target='_blank' ><MdArrowOutward size={20} className="text-dark mb-1" /> Discover</a>}
                                        </div>

                                        {/* {tripDetail?.hipPack?.type == 'pro' ?
                                            <a className=' bg-white border-2 rounded-[0px] border-black py-1 w-fit mx-auto px-2 font-quicksand font-semibold text-sm text-dark ' href={tripDetail?.hipPack?.url} target='_blank' ><MdArrowOutward size={20} className="text-dark mb-1" /> Discover</a>
                                            :
                                            <span className=' bg-white border-2 rounded-[0px] border-black py-1 w-fit mx-auto px-2 font-quicksand font-semibold text-sm text-dark ' >{tripDetail?.hipPack?.size}</span>
                                        } */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-wrap justify-center gap-3 my-8">
                            <Button
                                onClick={() => window.open('https://www.kickstarter.com/projects/westbreezetravel/packing-cubes-hanging-wardrobe-instantly', '_blank')}
                                label={
                                    <div className="flex items-center text-center w-fit">
                                        <MdArrowOutward size={20} className="text-dark" />
                                        <span className="text-[14px] whitespace-nowrap flex items-center gap-4">
                                            Explore & Early Bird Access
                                        </span>
                                    </div>
                                }
                                className="flex flex-col items-center border-2 border-dark px-4 py-2 font-quicksand text-dark font-bold text-[14px] bg-white w-fit"
                            />
                            <Button
                                onClick={savePackingListHandel}
                                label={
                                    <div className="flex items-center text-center gap-1">
                                        <AiOutlineHeart size={20} className="text-dark " />
                                        <span className="text-[14px] whitespace-nowrap">
                                            {saveLoading ? 'Saving' : 'Save Packing List'}

                                        </span>
                                    </div>
                                }
                                className="flex flex-col items-center border-2 border-dark px-4 py-2 font-quicksand text-dark font-bold text-[14px] bg-white w-fit"
                            />
                            <Button
                                onClick={() => navigate(-1)}
                                label={
                                    <div className="flex items-center text-center gap-1">
                                        <FaArrowLeft size={20} className="text-dark" />
                                        <span className="text-[14px] whitespace-nowrap flex items-center gap-4">
                                            Back To Packing Lists
                                        </span>
                                    </div>
                                }
                                className="flex flex-col items-center border-2 border-dark px-4 py-2 font-quicksand text-dark font-bold text-[14px] bg-white w-fit"

                            />
                        </div>
                    </div>
                </div>
            }

            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-4 rounded-lg shadow-lg w-[80%] h-[80vh] relative">
                        <button
                            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                            onClick={() => setIsModalOpen(false)}
                        >
                            <AiOutlineClose size={20} />
                        </button>
                        {
                            tripDetail?.youtubeUrl ?
                                <div className="my-5">
                                    <ReactPlayer url={tripDetail?.youtubeUrl} height={`70vh`} width={`100%`} light={true} controls muted />
                                </div>
                                :
                                <div className="my-5 text-dark font-roboto-mono font-bold text-lg text-center">
                                    No Video Url find
                                </div>
                        }
                    </div>
                </div>
            )}

        </>

    )
}

export default TripDetails
